import autosize from 'autosize/dist/autosize';


'use strict';


var ad_textArea = function () {
  var self = this;

  self.init();
  self.bind();
};

ad_textArea.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_textArea');

  jQuery(document).arrive(
    '.ad_textArea',
    function (localSelf) {
      localSelf.init_textArea();
    }.bind(null, self)
  );

  jQuery(document).on(
    'shown.bs.modal',
    function (localSelf) {
      localSelf.update_instances();
    }.bind(null, self)
  );



};

ad_textArea.prototype.init = function () {
  var self = this;

  // console.log('init ad_textArea');

   self.init_textArea();
};


ad_textArea.prototype.init_textArea = function () {
  var self = this;

  jQuery('.ad_textArea').each(function (/*localSelf*//*index*/) {
    var element = jQuery(this);

    var textArea = element.find('textarea');

    if (element.hasClass('st_mounted') === false) {

      autosize(textArea);

      self.instances.push(element);

      element.addClass('st_mounted');
    }

  }/*.bind(null, self)*/);

};


ad_textArea.prototype.instances = [];

ad_textArea.prototype.update_instances = function () {
  var self = this;

  for (var i = 0; i < self.instances.length; i++) {
    //console.log(jQuery(self.instances[i]).find('textarea'));
    //autosize(jQuery(self.instances[i]).find('textarea') );

    // Dispatch a 'autosize:update' event to trigger a resize:
    var evt = document.createEvent('Event');
    evt.initEvent('autosize:update', true, false);
    jQuery(self.instances[i]).find('textarea')[0].dispatchEvent(evt);

  }

};




jQuery( document ).ready(function() {

  window.ad_textArea = new ad_textArea();

});



